module.exports = __webpack_public_path__ + "static/img/image-not-available.300f4a6f.png";